module.exports = __webpack_public_path__ + "static/media/groupe-adène.d0b5a63b.png";